/**
 * När den obligatoriska rutan för förvald utlämningsplats ska visas,
 * och hur en supportinloggning kan stänga den.
 */

export function shouldPromptForDefaultPickup(input: {
  isImpersonating: boolean;
  hasDefaultPickup: boolean;
  pickupLocationCount: number;
}): boolean {
  // Global admin som växlat till användaren ska kunna jobba utan att
  // tvingas spara ett förval på den användarens konto.
  if (input.isImpersonating) return false;
  if (input.hasDefaultPickup) return false;
  if (input.pickupLocationCount < 1) return false;
  return true;
}

/** Ctrl+Shift+M (eller Cmd+Shift+M). Stänger rutan utan att spara. */
export function isPickupPromptDismissShortcut(event: {
  key: string;
  ctrlKey: boolean;
  shiftKey: boolean;
  metaKey: boolean;
  altKey: boolean;
}): boolean {
  if (event.altKey || !event.shiftKey) return false;
  if (!event.ctrlKey && !event.metaKey) return false;
  return event.key.toLowerCase() === 'm';
}
